'use strict';

module Patersons {

    export class NavigationService {

        sections = ['dashboard', 'portfolio', 'analysis', 'research'];

        constructor() {
        }

        activateSection(section: string): void {
            this.deactivateAll();

            var sectionDiv = angular.element(document.querySelector('#' + section+'-section'));
            sectionDiv.addClass('active-section');
        }

        deactivateSection(section: string): void {
            var sectionDiv = angular.element(document.querySelector('#' + section + '-section'));
            sectionDiv.removeClass('active-section');
        }

        deactivateAll(): void {
            for (let section of this.sections) {
                let sectionDiv = angular.element(document.querySelector('#' + section + '-section'));
                sectionDiv.removeClass('active-section');
            }
        }
    }
}
